import React, { useEffect, useMemo, useState } from "react";

import "./badgeFileInput.scss";

const BadgeFileInput = ({ id, name, label, disabled, onChange }) => {
  const inputId = useMemo(() => id || name, [id, name]);
  const [fileName, setFileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const handleChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;

    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    if (file) {
      setFileName(file.name);
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setFileName("");
      setPreviewUrl("");
    }

    if (typeof onChange === "function") {
      onChange(e);
    }
  };

  return (
    <div className="badge-file-input">
      <div className="badge-file-input__label">{label}</div>

      <label
        className={[
          "badge-file-input__dropzone",
          disabled ? "is-disabled" : "",
          previewUrl ? "has-preview" : "",
        ].join(" ")}
        htmlFor={inputId}
      >
        <input
          id={inputId}
          name={name}
          type="file"
          accept="image/*"
          disabled={disabled}
          onChange={handleChange}
          className="badge-file-input__native"
        />

        {previewUrl ? (
          <img
            src={previewUrl}
            alt="Vista previa"
            className="badge-file-input__preview"
          />
        ) : (
          <div className="badge-file-input__placeholder">
            <div className="badge-file-input__placeholder-title">
              Seleccionar imagen
            </div>
            <div className="badge-file-input__placeholder-subtitle">
              PNG / JPG / WEBP
            </div>
          </div>
        )}
      </label>

      <div className="badge-file-input__filename">
        {fileName ? fileName : "Sin archivo"}
      </div>
    </div>
  );
};

export default BadgeFileInput;
